<sc-padding [fitHeight]="true" class="send-message-dialog">
    <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
        <sc-sub-title>{{'an alle Transporte senden'| translate:['tmc-yard.widget.send-message.current-transport', translationService.language]}}</sc-sub-title>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <app-transport-info-panel [carrier]="transport?.masterdata.carrier" [driver]="transport?.name"
            [identifier]="transport?.identifyingNumberplate" [scope]="transport?.masterdata.transportScope"></app-transport-info-panel>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-sub-title>{{'an alle Transporte senden'| translate:['tmc-yard.widget.send-message.messages', translationService.language]}}</sc-sub-title>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <sc-flex-fitting-content [vertical]="true">
          <sc-scroll-pane>
            <div class="messages">
                <div class="message" [ngClass]="{ 'selected': selected === message }"
                    *ngFor="let message of messages" (click)="selectMessage(message)">
                    <sc-padding>
                        <sc-flex >
                            <sc-icon iconClass="fa-envelope"></sc-icon>
                            <sc-content-spacer></sc-content-spacer>
                            <sc-flex-fitting-content>
                                <div class="label">{{message.name}}</div>
                            </sc-flex-fitting-content>
                        </sc-flex>
                    </sc-padding>
                </div>
                <div *ngIf="messages?.length == 0">
                    <sc-padding>{{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}</sc-padding>
                </div>
            </div>
          </sc-scroll-pane>
        </sc-flex-fitting-content>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-flex >
            <button mat-stroked-button [disabled]="selected == null" (click)="sendMessageAllTransports()">
                {{'an alle Transporte senden'| translate:['tmc-yard.widget.send-message.action.all-transports', translationService.language]}}
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-stroked-button [disabled]="selected == null" (click)="sendMessageAllTransportsOnYard()">
                {{'an alle Transporte im Werk senden'| translate:['tmc-yard.widget.send-message.action.all-transports-in-yard', translationService.language]}}
            </button>
            <sc-content-spacer [grow]="true"></sc-content-spacer>
            <button mat-flat-button [disabled]="selected == null || transport == null || !transportHasMessaging" (click)="sendMessageCurrentTransport()">
                {{'an den aktuallen Transport senden'| translate:['tmc-yard.widget.send-message.action.current-transport', translationService.language]}}
            </button>
        </sc-flex>
    </sc-flex>
</sc-padding>
